import gql from "graphql-tag";

const cmLog = gql`
  {
    id
    message
    date
    type
    tenant_id
    tenant{
    name
    tenant_group{
      name
      }
    }
    e_cm_logging_type {
      id
      comment
    }
      system_id
      thirdparty_id,
      payload
  }
`;

export const GET_LIST_CM_LOGGING = cmLog;
